import classNames from "classnames"
import { Badge } from "web/components"
import { pluralize } from "web/services/inflector"

export default function ResultTypeSelector({
  resultType,
  resultsByTypes,
  onChange = () => {},
}) {
  function classNameForType(type) {
    const selected = resultType === type

    return classNames(
      "border-primary-4 flex gap-x-2.5 px-3 py-2 font-medium rounded-md text-sm items-center",
      {
        "text-neutral-4 cursor-pointer hover:bg-primary-10": !selected,
        "bg-primary-10": selected,
      }
    )
  }

  return (
    <div className="mt-5 flex space-x-5">
      {resultsByTypes.map(({ type, count }) => {
        const selected = resultType === type

        if (count === 0) return null
        return (
          <div
            key={type}
            className={classNameForType(type)}
            onClick={() => onChange(type)}
          >
            <span>{pluralize(type)}</span>
            <Badge
              badgeColour={classNames({
                "bg-neutral-7": !selected,
                "bg-primary-4": selected,
              })}
            >
              {count}
            </Badge>
          </div>
        )
      })}
    </div>
  )
}
